<template>
  <div class="chat">
    <!-- 侧边栏 -->
    <NavBar :userInfo="userInfo" :chatList="chatList" @getHistory="getHistory" @newChat="newChat"></NavBar>

    <div class="chat-content">
      <!-- header -->
      <div class="header">
        <i class="iconfont luming-pc-ait_ai" style="color: #0057ff; font-size: 76px; margin-right: 15px; "></i>
        河南省高考志愿填报智能助手
      </div>

      <!-- 主显示内容 -->
      <div class="content-item" ref="messagesContainer">
        <!-- 提问查询导航栏 -->
        <nav-item style="width: 100%;" v-if="showChat" :key="nav_refresh" @sendChat="sendChat"></nav-item>

        <!-- 聊天信息 -->
        <div v-else>
          <div class="message-item">
            <!-- 聊天列表 -->
            <div v-for="(item, i) in messages" :key="i">
              <div style="display: flex; justify-content: flex-end;" v-if="item.role == 'user'">
                <div class="question" v-html="$options.filters.textShow(item.content)"></div>
              </div>
              <div style="display: flex; justify-content: flex-start;" v-if="item.role == 'assistant'">
                <div v-html="$options.filters.textShow(item.content)"></div>
              </div>
            </div>

            <!-- 大模型文字描述 -->
            <!-- 正在分析 -->
            <div v-if="isTyping" class="message assistant typing">
              <div style="display: flex; align-items: center; gap: 10px;">
                <img src="@/assets/img/chat/logo.png" style="width: 32px; height: 32px;" alt="">
                <span
                  style="background: #E6EAF6; color: #3D3D3D; font-size: 18px;padding: 0 5px; line-height: 35px;">报考高手志愿填报大模型正在为你解答中......</span>
              </div>
              <div v-if="markdownContent" class="markdown-content" v-html="markdownContent"></div>
              <div v-else class="markdown-content">
                正在分析您的问题...
              </div>
            </div>

            <!-- 底部工具拦 -->
            <div class="footer">
              <div class="down" @click="newChat()">
                <i class="iconfont luming-pc-down"
                  style="color: #8C8C8C; font-size: 18px; transform: rotate(90deg);  "></i>
                返回
              </div>
              <div class="down-1">
                <!-- <i class="iconfont luming-pc-copy" @click="isSidebarVisible = !isSidebarVisible"
                  style="color: #8C8C8C; font-size: 18px;"></i> -->
                <i class="iconfont luming-pc-like" @click="isSidebarVisible = !isSidebarVisible"
                  style="color: #8C8C8C; font-size: 18px;"></i>
                <i class="iconfont luming-pc-not-like" @click="isSidebarVisible = !isSidebarVisible"
                  style="color: #8C8C8C; font-size: 18px;"></i>
                <i class="iconfont luming-pc-shanchu1" @click="isSidebarVisible = !isSidebarVisible"
                  style="color: #8C8C8C; font-size: 18px;"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 聊天框 -->
      <div v-if="inputState">
        <!-- 欢迎信息 -->
        <div class="aaff8b8f">
          <form @submit.prevent="sendMessages">
            <!-- 输入框 -->
            <div class="input-content">
              <textarea ref="textarea" class="input-textarea" placeholder="结合上方问题继续发问" v-model="inputMessage"
                @input="onInput"></textarea>
            </div>
            <!-- 输入框下的工具栏 -->
            <div class="tools">
              <button class="tools-btn" type="submit" :disabled="isLoading || !inputMessage.trim()">
                <span v-if="!isLoading">
                  <i class="iconfont luming-pc-down" style="color: #0057ff; font-size: 36px;  "></i>
                </span>
                <span v-else>
                  <i class="iconfont luming-pc-down" style="color:rgb(140, 140, 140); font-size: 36px;  "></i>
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div style="text-align: center; font-size: 12px; padding: 10px; color: #81858c;" v-if="!showChat">

        内容由AI生成，请注意甄别
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import NavBar from './components/NavBar/index'
import NavItem from './components/NavBar/item'
import { marked } from 'marked';
export default {
  name: 'ChatWindow',
  components: {
    NavBar,
    NavItem,
  },

  computed: {
    ...mapState(["userInfo"]),

    markdownContent() {
      return marked(this.partialResponse)
    },
  },
  filters: {
    textShow(e) {
      return marked(e)
    },
  },
  data() {
    return {

      nav_refresh: 1,
      // 聊天组件是否显示
      showChat: true,
      //聊天列表
      chatList: {},
      // 输入框信息
      inputMessage: '',
      // 聊天列表
      messages: [],

      //聊天资源
      eventSource: null,
      // 回答信息中
      isTyping: false,

      scroll: true,

      //加载中
      isLoading: false,

      //回答的信息-流模式输出用
      partialResponse: '',

      // ------------------
      // 发送的消息-等结果出来上传到数据库保存
      old_inputMessage: {},
      chat_id: null,
      inputState: false
    };
  },

  mounted() {
    const foot = document.getElementById("footer");
    const header = document.getElementById("LuHead");
    foot.style.display = "none";
    header.style.display = "none";

    // 个人信息
    if (!this.userInfo) {
      console.log('error')
      return false
    }

    //获取聊天记录
    this.getChatList()
  },

  methods: {

    // //开启新聊天
    newChat() {
      this.inputState = false
      this.nav_refresh++;
      this.$nextTick(() => { // 确保DOM更新后，再显示子组件
        this.showChat = true
      });
    },
    sendChat(e) {
      // 初始化聊天信息
      this.refreshMessage(e.type, e.title)
      //创建聊天
      this.createChat(e)
    },

    // 第一次聊天 - 直接添加

    async createChat(e) {
      try {
        // 如果是百问百答 显示输入框
        if (e.type == '1') {
          this.inputState = true
          // 判断 - 如果没有聊天记录。创建新对话
          let state = await this.getSystemHistory(e)
          //创建新对话
          if (state == 'none') {
            this.sendMessage(e)
          }
        } else {
          this.inputState = false
          // 如果是其他问题
          this.sendMessage(e)
        }
      } catch (error) {
        console.error('Error occurred:', error);
        throw error; // 可以选择抛出错误或进行其他处理
      }
    },

    // 第一次聊天发送请求
    async sendMessage(item) {
      // let urlstr = 'http://newluming.com/index.php/api/chat/create_chat';
      let urlstr = 'https://bkgaoshou.com/index.php/api/chat/create_chat';

      let params = {
        user_id: this.userInfo.id,
        is_wenli: this.userInfo.is_wenli,
        score: this.userInfo.score,
        ranking: this.userInfo.ranking,
        like_city: this.userInfo.like_city,
        like_sp: this.userInfo.like_sp,
        type: item.type,
        question: JSON.stringify(item),
      }
      let url = this.createGetRequestUrl(
        urlstr,
        params)
      try {
        // 使用Server-Sent Events实现流式响应
        this.eventSource = new EventSource(url);
        // 消息返回状态处理
        this.eventSourceResult()
      } catch (error) {
        // 错误日志 -- 暂不处理
        // this.addAiMessage('发送消息失败', 2);
        this.isLoading = false;
        this.isTyping = false;
      }
    },

    // 多轮聊天
    async sendMessages() {
      this.scrollToBottom()
      this.isLoading = true;
      this.isTyping = true;
      this.partialResponse = ''
      let urlstr = ''
      // urlstr = 'http://newluming.com/index.php/api/chat/more_chats'
      urlstr = 'https://bkgaoshou.com/index.php/api/chat/more_chats'

      let params = {
        inputMessage: this.inputMessage,
        chat_id: this.chat_id
      }

      this.messages.push({
        'role': 'user', 'content': this.inputMessage
      })

      this.inputMessage = ''
      let url = this.createGetRequestUrl(
        urlstr,
        params)
      try {
        // 使用Server-Sent Events实现流式响应
        this.eventSource = new EventSource(url);
        // 消息返回状态处理
        this.eventSourceResult()
      } catch (error) {
        // this.addAiMessage('发送消息失败', 2);
        this.isLoading = false;
        this.isTyping = false;
      }
    },

    // 第一次消息返回状态处理
    eventSourceResult() {
      // 系统处理逐字输出快速展示
      this.eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.content) {
          this.partialResponse += data.content;
          this.scrollToBottom();
        }
      };

      //错误了处理
      this.eventSource.addEventListener('error', (event) => {
        console.error(event);
        this.isLoading = false;
        this.isTyping = false;
        this.eventSource.close();
      });

      // 结束了处理
      this.eventSource.addEventListener('done', () => {
        this.addAiMessage(this.partialResponse)
        this.isLoading = false;
        this.isTyping = false;
        this.eventSource.close();
      });
    },

    // 更新聊天记录到数据库
    addAiMessage(event) {
      this.messages.push({
        'role': 'assistant', 'content': event
      })

      let message = {
        'role': 'assistant', 'content': event
      }

      // 数据整合上传到数据库
      let data = {
        user_id: this.userInfo.id,
        title: this.old_inputMessage.title,
        type: this.old_inputMessage.type,
        message: JSON.stringify(message),
      }
      this.$fecth.post('chat/update_chat', data).then((res) => {
        this.chat_id = res
        // 添加聊天到侧边栏
        this.getChatList()
      })
      this.scrollToBottom();
    },

    // -------------------------------

    // 查询是否有数据
    getSystemHistory(e) {
      return new Promise((resolve, reject) => {
        console.log(reject)
        let data = {
          user_id: this.userInfo.id,
          title: e.title,
        }
        this.$fecth.post('chat/get_chat', data).then((res) => {
          // 添加聊天到侧边栏
          if (res) {
            this.chat_id = res.id
            this.messages = JSON.parse(res.result)
            this.isLoading = false;
            this.isTyping = false;
            resolve('success')
          }
          else {
            resolve('none')
          }
        })
      })
    },

    //发起聊天- 刷新各参数
    refreshMessage(type, title) {
      // 清空聊天记录
      this.messages = []
      this.showChat = false

      //记录聊天消息  
      this.old_inputMessage = {
        // 问题
        title: title.trim(),
        type: type
      };
      this.messages = [
        {
          'role': 'user', 'content': title
        },
      ]
      // 加载聊天状态
      this.isLoading = true;
      this.isTyping = true;
      //重置系统返回的数据
      this.partialResponse = '';
      // 滚动条移动到最下面
      this.scrollToBottom();
    },

    // 获取聊天记录
    getChatList() {
      let data = {
        user_id: this.userInfo.id,
      }
      this.$fecth.post('chats/chat_list', data).then((res) => {
        this.chatList = res
      })
    },

    //查看聊天记录
    getHistory(e) {
      this.chat_id = e.id

      this.old_inputMessage = {
        // 问题
        title: e.title,
        type: e.type
      };

      if (e.type == 1) {
        this.inputState = true
      } else {
        this.inputState = false
      }
      this.messages = JSON.parse(e.result)
      this.showChat = false
    },

    //聊天滚动条到最下方
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messagesContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },

    onInput() {
      this.$nextTick(() => {
        const textarea = this.$refs.textarea;
        textarea.style.height = 'auto';
        if (textarea.scrollHeight < 50) {
          textarea.style.height = 50 + 'px'
        } else {
          textarea.style.height = textarea.scrollHeight + 'px';
        }
      });
    },
    // 将参数对象转换成查询字符串
    createGetRequestUrl(baseUrl, params) {
      // 将参数对象转换成查询字符串
      const queryString = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');

      // 返回完整的URL
      return `${baseUrl}?${queryString}`;
    },
  },
  beforeUnmount() {
    // 关闭事件源
    if (this.eventSource) {
      this.eventSource.close();
    }
  },
  beforeDestroy() {
    const foot = document.getElementById("footer");
    foot.style.display = "block";
    const header = document.getElementById("LuHead");
    header.style.display = "block";
  },

};
</script>

<!-- /* 过渡动画效果 */ -->
<style lang="less" scoped>
/* 过渡动画效果 */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}

.fade-enter {
  opacity: 0;
  transform: translateX(30px);
}

.fade-leave-to {
  opacity: 0;
  transform: translateX(-30px);
  position: absolute;
}

.el-menu-vertical-demo {
  border-right: 0;
}
</style>

<!-- 内容css -->
<style lang="less" scoped>
.chat {
  width: 100%;
  min-width: 1100px;
  display: flex;
}

.chat-content {
  flex: 1 1;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;

  .header {
    width: 100%;
    font-size: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding-top: 20px;
  }

  .content-item {
    flex: 1 1;
    height: 100%;
    display: flex;
    width: 1200px;
    padding: 30px calc((100% - 1200px)/2);
    overflow: hidden;
    overflow-y: auto;
    scrollbar-color: #ebebfc transparent;
    scrollbar-width: thin;
  }
}
</style>

<!-- 输入框 -->
<style lang="less" scoped>
.message-item {
  width: 1200px;
  position: relative;

  .question {
    color: #3D3D3D;
    border-radius: 20px 20px 20px 20px;
    margin-bottom: 10px;
    background: #E6EAF6;
    padding: 1px 12px;
    line-height: 10px;
    margin-right: 0;
  }
}

.footer {
  display: flex;
  justify-content: space-between;
  padding: 20px 0 50px 0;
  border-top: 2px solid #D8D8D8;
  margin-top: 30px;

  .down {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .down-1 {
    display: flex;
    align-items: center;
    gap: 20px;
  }
}

.aaff8b8f {
  display: flex;
  flex-grow: 1;
  width: 80%;
  margin: 0 auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, .02), 0 2px 2px rgba(72, 104, 178, .01), 0 30px 60px rgba(72, 104, 178, .03);
  cursor: text;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 50px;
  transition: box-shadow .2s cubic-bezier(.4, 0, .2, 1);
  border: 2px solid #F2F2F2;
  background: #fff;
  border-radius: 24px;
  flex-direction: column;
  padding: 12px;
  margin-top: 20px;

  .input-textarea {
    width: 100%;
    resize: none;
    border: none;
    outline: none;
    height: auto;
    color: #0f1115;
    caret-color: #3964fe;
    background-color: transparent;
    box-sizing: border-box;
    font-size: 16px;
  }

  .tools {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    overflow: hidden;

    .tools-item {
      border-radius: 18px;
      overflow: hidden;
      padding: 0px 12px;
      height: 34px;
      font-size: 13px;
      line-height: 34px;
      cursor: pointer;
      box-sizing: border-box;
    }

    .tools-btn {
      background: white;
      display: inline-block;
      margin-left: auto;
      cursor: pointer;
      padding: 0px 16px;
      border: none;
      border-radius: 4px;
      font-size: 14px;
      transform: rotate(180deg);
    }

    .tools-btn:disabled {
      cursor: not-allowed;
    }
  }
}
</style>
